// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__zSGbb","consentsList":"PatientConsents_consentsList__3bBR_","consentsListEmpty":"PatientConsents_consentsListEmpty__3Q5v7"};